import { useParams } from 'react-router-dom';

//Use this hook just on pages and routes where the eventkey is 100% defined
export const useBrandPortalEventKey = () => {
  const { event } = useParams();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return event!;
};
